import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";

export default class Will extends  Model{
    static entity = 'Household\\Model\\Will';

    static fields() {
        return {
            id: this.attr(null),
            attorney_name: this.attr(''),
            attorney_contact: this.attr(''),
            note: this.attr(''),
            household_id: this.number(null),
            beneficiaryAssignments: this.morphMany(BeneficiaryAssignment, 'assignable_id', 'assignable_type'),
        }
    }
}
